import includes from 'lodash-es/includes'

export default (props: any) => {
  const sizeDefault = ['mini', 'small', 'large', 'x-large']

  const colorClass = computed(() => {
    if (!$lodash.isNil(props.color)) {
      return `color-${props.color}`
    }
    return ''
  })

  const sizeClass = computed(() => {
    if (includes(sizeDefault, props.size)) {
      return `size-${props.size}`
    }
    return ''
  })

  const cClass = computed(() => {
    return {
      [colorClass.value]: true,
      [sizeClass.value]: true
    }
  })

  const wClass = computed(() => {
    switch (props.width) {
      case 'full':
        return 'w-full'
      default:
        return ''
    }
  })
  return {
    cClass,
    colorClass,
    sizeClass,
    wClass
  }
}
